export const typeAffectsOptions = [
    {value: "No", label: "No", color: "#76AEB7"},
    {value: "+", label: "+", color: "#76AEB7"},
    {value: "-", label: "-", color: "#76AEB7"}
]

export const typeAffectsOptionsSearch = [
    {value: "null", label: "Κενό", color: "#76AEB7"},
    {value: "No", label: "No", color: "#76AEB7"},
    {value: "+", label: "+", color: "#76AEB7"},
    {value: "-", label: "-", color: "#76AEB7"}
]

const toExcelLetter = (n) => {
    let s = "";
    for (n++; n > 0; n = Math.floor((n - 1) / 26)) s = String.fromCharCode(65 + ((n - 1) % 26)) + s;
    return s;
};

const EXCEL_COLUMNS_COUNT = 60; // A ... CV, change as needed

export const excelOptions = [
    {value: "", label: "Κενό", color: "#76AEB7"},
    ...Array.from({length: EXCEL_COLUMNS_COUNT}, (_, i) => ({
        value: i === 0 ? 0 : String(i),
        label: toExcelLetter(i),
        color: "#76AEB7",
    })),
];